/**
 * SIGEIF organization id.
 * Same default as `DEFAULT_IZIVIA_MONPROJET_ORGANIZATION_ID` in
 * `apps/izivia_automation` and the Metis OCPP logs trigger.
 */
export const SIGEIF_ORGANIZATION_ID = '6ff9e1bb-38bf-4509-806e-99b454283ddb';
